import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import MenuService from '../../../services/menu';
import User from '../../../services/user';
import { ROLES_MANAGER_TYPE, TYPE_MENU } from '../../../utils/enums';
import { isSameObjects } from '../../../utils/objects-util';
import { actionMenuPriorityUpdate } from '../../../store/reducers/menu/menu-actions';
import RoleManager from '../../../services/roleManage';
import { toggleNestedMenu } from '../../../store/reducers/menu/menu-actions';

// Line icons for the mobile menu panel, keyed by the item's translation key (the only
// stable identity a MenuModel has). Hidden on the desktop header tabs via CSS.
// Same stroke style as UserControlsMenu's icons; not class "icon" — a legacy stylesheet
// styles .icon globally with a sprite background.
const NAV_ICON_PATHS = {
  'header.menu.DASHBOARD_LABEL': (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </>
  ),
  'header.menu.ORDERS_LABEL': (
    <>
      <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" />
      <path d="M3 8l9 5 9-5" />
      <path d="M12 13v8" />
    </>
  ),
  'header.menu.MARKETPLACE_SETTINGS': (
    <>
      <path d="M3 10v4a1 1 0 0 0 1 1h2l5 4V5L6 9H4a1 1 0 0 0-1 1z" />
      <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    </>
  ),
  'header.menu.SETTINGS_LABEL': (
    <>
      <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3" />
      <path d="M1 14h6M9 8h6M17 16h6" />
    </>
  ),
  'settings.SHIFTS_TITLE': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 3" />
    </>
  ),
  'header.menu.REPORTS_LABEL': (
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M8 13h8M8 17h5" />
    </>
  ),
  'header.menu.ANALYTICS_LABEL': (
    <>
      <path d="M22 7l-8.5 8.5-5-5L2 17" />
      <path d="M16 7h6v6" />
    </>
  ),
  'header.menu.ADMIN_ORDERS_LABEL': (
    <>
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3zM3 19a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H3z" />
    </>
  ),
  'header.menu.RESTAURATEUR_MENU_LABEL': (
    <>
      <path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z" />
      <path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z" />
    </>
  ),
};

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuItems: []
    };

    this.headerMenuRefs = [];
    this.menuParentRef = React.createRef();
    this.handleOnResize = this.handleOnResize.bind(this);
  }

  componentDidMount() {
    this.updateMenuItems();
    window.addEventListener("resize", this.handleOnResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleOnResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const { language } = this.props;

    if (language !== prevProps.language) {
      this.updateMenuItems(false, true);
    }
  }

  handleOnResize = () => {
    const { clientWidth } =
      (this.menuParentRef && this.menuParentRef.current) || {};
    const refsWidth = (this.headerMenuRefs || [])
      .filter(f => f && f.ref)
      .reduce((a, b) => a + b.ref.clientWidth, 0);
    this.updateMenuItems(clientWidth < refsWidth);
  };

  handleOnClick = path => {
    const { history, toggleNestedMenu } = this.props;
    if(this.props.toggleMobileMenu) {
      this.props.toggleMobileMenu(false);
    }
    toggleNestedMenu(false)
    history.push(path);
  };

  updateMenuItems = (isSort, isRecreate) => {
    const { menuItemState, rootState } = this.props;
    const { menuItems } = this.state;
    const newMenuItems = MenuService.instance.getMenu(
      TYPE_MENU.header,
      isSort,
      isRecreate
    );
    const filteredMenuItems = newMenuItems
      .filter(menu=> !menu.isShow || menu.isShow({ ...rootState, ...menuItemState }));

    if (isSameObjects(menuItems, filteredMenuItems)) return
    this.setState({ menuItems: filteredMenuItems });
  };


  render() {
    const { menuItems } = this.state;
    const { t, rootState, location, hideMenu, menuItemState } = this.props;
    this.headerMenuRefs = [];
    return (
      <>
        <menu className={classNames("headerMenu")} ref={this.menuParentRef}>
          {!hideMenu &&
            menuItems
              .filter(
                menu =>
                  RoleManager.instance.isAuthorized(
                    ROLES_MANAGER_TYPE.menu,
                    menu.pathname
                  ) &&
                  (!menu.isShow || menu.isShow({ ...rootState, ...menuItemState }))
              )
              .map(headerMenu => (
                <li
                  key={`headerMenu-${headerMenu.title}`}
                  className={classNames(`menuItem`, {
                    active: headerMenu.active(location)
                  })}
                  onClick={() => this.handleOnClick(headerMenu.pathname)}
                >
                  <div className={classNames("menuItemTitle")}>
                    {/* Rendered even when the key has no icon yet: the empty box keeps
                        every mobile row's text on the same edge (LTR and RTL alike). */}
                    <svg className={"menu-nav-icon"} viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                         strokeLinejoin="round" aria-hidden="true">
                      {NAV_ICON_PATHS[headerMenu.title]}
                    </svg>
                    {t(headerMenu.title)}
                    {headerMenu.badgeCount && headerMenu.badgeCount() && (
                        <div className={'badge'}>
                          {headerMenu.badgeCount()}
                        </div>
                    )}
                  </div>
                  {!!headerMenu.isWithIcon &&
                    !!headerMenu.isWithIcon(rootState) && (
                      <div className={classNames("menuItemIcon", {relativeIcon: headerMenu.isIconRelative})}>
                        {headerMenu.isWithIcon(rootState)}
                      </div>
                    )}
                </li>
              ))}
        </menu>
      </>
    );
  }
}

const mapStateToProps = state => ({
  menuItemState: {
    businessMenu: state.restaurant.data.businessMenu,
    consumerOrderMenu: state.restaurant.data.consumerOrderMenu,
    paymentsConfiguration: state.restaurant.data.paymentsConfiguration
  },
  rootState: state,
  language:
    User.instance.getCurrentUserInfo() &&
    User.instance.getCurrentUserInfo().configuration.language
});

const mapDispatchToProps = dispatch => {
  return {
    menuPriorityUpdate: data => dispatch(actionMenuPriorityUpdate(data)),
    toggleNestedMenu: data => dispatch(toggleNestedMenu(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(Menu))
);
